import { Overlay, OverlayConfig } from '@angular/cdk/overlay';
import { ComponentPortal } from '@angular/cdk/portal';
import { DatePipe } from '@angular/common';
import {
  Component,
  OnInit,
  ViewContainerRef,
  Output,
  EventEmitter
} from '@angular/core';
import { MatDatepickerInputEvent } from '@angular/material/datepicker';
import { TranslateService } from '@ngx-translate/core';
import { AuthenticationService } from '../../../@core/services/authentication.service';
import { SectorService } from '../../../@core/services/sector.service';
import { StopService } from '../../../@core/services/stop.service';
import { UserProfileComponent } from '../user-profile/user-profile.component';
import { Router } from '@angular/router';
import { OnHoldService } from '../../../@core/services/onhold.service';
import { ApiProvider } from '../../../@core/providers/api.provider';
import { HttpErrorResponse } from '@angular/common/http';
import { Stops } from '../../../@core/models/live-route';
import { AngularFireDatabase } from '@angular/fire/database';
import { removeSummaryDuplicates } from '@angular/compiler';
import { MatDialog } from '@angular/material';
import { UserPreferencesDialogComponent } from '../user-preferences-dialog/user-preferences-dialog.component';
import { ProgressSpinnerComponent } from '../progress-spinner/progress-spinner.component';
import { SpinnerService } from '../../../@core/services/SpinnerService';
import { ParcelHistoryDialogComponent } from '../parcel-history-dialog/parcel-history-dialog.component';
import { environment } from '../../../../environments/environment';
import { FormControl } from '@angular/forms';
import { ProblemReportDialogComponent } from '../problem-report-dialog/problem-report-dialog.component';
import { ProblemReportDraftService } from '../../../@core/services/problem-report-draft.service';
import { NatLanguage } from '../../../@core/models/nat-language';

@Component({
  selector: 'ngx-header',
  styleUrls: ['./header.component.scss'],
  templateUrl: './header.component.html',
  providers: []
})
export class HeaderComponent implements OnInit {
  public get languageToBeChanged(): string {
    return this.translateService.currentLang === 'fr' ? 'EN' : 'FR';
  }
  public dateString: string;
  public dayDate: Date;
  public selectedSectorId: number = 0;
  public nextPosition: number = 0;
  public dateF: any = new Date();
  public isMenuOpen: boolean = false;
  @Output() onToggle = new EventEmitter<string>();
  currentApplicationVersion = environment.appVersion;
  toggleTheme: FormControl;
  @Output() onToggleTheme = new EventEmitter<boolean>();

  constructor(
    private translateService: TranslateService,
    public authenticationService: AuthenticationService,
    public _sectorService: SectorService,
    public _stopService: StopService,
    public _onholdService: OnHoldService,
    public overlay: Overlay,
    public dialog: MatDialog,
    public router: Router,
    public viewContainerRef: ViewContainerRef,
    public datePipe: DatePipe,
    public apiProvider: ApiProvider,
    public db: AngularFireDatabase,
    public SpinService: SpinnerService,
    private problemReportDraftService: ProblemReportDraftService
  ) {
    this.dayDate = new Date();
    this.dateString = this.dayDate.toISOString();
    this._sectorService.RouteDate = this.dayDate;
    this.dateF = this.datePipe.transform(this.dayDate, 'yyyy-MM-dd');
  }

  ngOnInit() {
    let calendardate = new Date();
    this.toggleTheme = new FormControl(false);
    this.dayDate = calendardate;
    this.dateString = this.dayDate.toISOString();
    this._sectorService.RouteDate = this.dayDate;
    this._onholdService.RouteDate = this.dayDate;
    this.dateF = this.datePipe.transform(this.dayDate, 'yyyy-MM-dd');

    const sectorIds = this.authenticationService.currentUserValue.SectorIds;
    if (sectorIds !== null && sectorIds.length === 1) {
      this._sectorService.SectorID = sectorIds[0];
      this._sectorService.initialiseSector();
      this._sectorService.initialiseSectorOnHold();
    }

    this.toggleTheme.valueChanges.subscribe((toggleValue) => {
      this.onToggleTheme.emit(toggleValue);
    });

    if (this.problemReportDraftService.get()) {
      this.reportProblem();
    }
  }

  public toggleMenu(): void {
    this.onToggle.emit(null);
  }

  public searchByParcelId() {
    const dialogRef = this.dialog.open(ParcelHistoryDialogComponent, {
      height: '700px',
      width: '1400px',
      data: { search: true }
    });
  }

  public logout(): void {
    this._sectorService.ResetCurrentSectprValue();
    this.problemReportDraftService.clear();
    this.authenticationService.logout();

    this.router.navigate(['/login']);
  }

  public changeLanguage(): void {
    const setLanguage: string = this.languageToBeChanged.toLowerCase();
    this.translateService.use(setLanguage);
    this.authenticationService.updateLanguage = setLanguage === 'fr' ? NatLanguage.Fr : NatLanguage.En;
  }

  public userPreferences(): void {
    const dialogRef = this.dialog.open(UserPreferencesDialogComponent, {
      width: '600px'
    });
  }

  public reportProblem(): void {
    this.dialog.open(ProblemReportDialogComponent, { width: '680px', maxWidth: '95vw', disableClose: true });
  }

  public addEvent(event: MatDatepickerInputEvent<Date>) {
    /*
    this.SpinService.cdkSpinnerCreate();
    this.SpinService.showSpinner();*/

    this._sectorService.RouteDate = event.value;
    this._stopService.RouteDate = event.value;
    this._onholdService.RouteDate = event.value;
    this._onholdService.initialiseOnholdRoute();
    this._sectorService.initialiseSector();
    this._stopService.initialiseRoute();
  }

  public setSelectedSectorId(sectorId: number) {
    this._sectorService.SectorID = sectorId;
    this._stopService.RouteID = -1;
    this._stopService.ResetService();

    //this.SpinService.cdkSpinnerCreate();
    //this.SpinService.showSpinner();

    this._sectorService.initialiseSector();
    this._onholdService.initialiseOnholdRoute();
  }

  public ShowUserProfileMenu() {
    let config = new OverlayConfig();

    config.positionStrategy = this.overlay
      .position()
      .global()
      .left(`${this.nextPosition}px`)
      .top(`${this.nextPosition}px`);

    this.nextPosition += 30;

    config.hasBackdrop = true;

    let overlayRef = this.overlay.create(config);

    overlayRef.backdropClick().subscribe(() => {
      overlayRef.dispose();
    });

    overlayRef.attach(
      new ComponentPortal(UserProfileComponent, this.viewContainerRef)
    );
  }
  public IsAfter7pm(): boolean {
    const now = new Date();
    const nowTime = new Date(
      now.getMonth() +
        1 +
        '/' +
        now.getDate() +
        '/' +
        now.getFullYear() +
        ' ' +
        now.getHours() +
        ':' +
        now.getMinutes()
    );
    const userTime = new Date(
      now.getMonth() +
        1 +
        '/' +
        now.getDate() +
        '/' +
        now.getFullYear() +
        ' ' +
        '19:00'
    );

    return nowTime.getTime() > userTime.getTime();
  }
}
